import { AgGridVue } from 'ag-grid-vue'
import { loading, toast } from '@/shared/utils/UIHelper'
import PDRRepository from '@/shared/http/repositories/pci/pdr'
import PDRObraAvaliacaoRepository from '@/shared/http/repositories/pci/pdrobraavaliacao'
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import gridMixin from '../mixins/gridMixin'
import CompanyMixin from '@/store/module/company/mixin'

export default {
  name: 'PdrBonusPayment',
  mixins: [gridMixin, CompanyMixin],
  data () {
    return {
      grid: null,
      totalWorkRows: 0,
      obrasRowData: [{}],
      printPdrObraID: null,
      generatedMembers: [],
      exceptionGeneration: null,
      membersColumDefs: [
        { key: 'nome', label: 'Nome' },
        { key: 'valorLiquidoPDR', label: 'Valor', formatter: value => (value) ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'N/D' },
        { key: 'pdrPedido', label: 'Pedido' }
      ],
      obrasDataGridOptions: {
        headerHeight: 45,
        rowHeight: 30
      },
      obrasColumnDefs: [
        {
          headerName: this.$lang.PCI.PdrBonusPayment.DataTable.Code,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          field: 'referencia'
        },
        {
          headerName: this.$lang.PCI.PdrBonusPayment.DataTable.IdSite,
          field: 'idSite'
        },
        {
          headerName: this.$lang.PCI.PdrBonusPayment.DataTable.Contract,
          field: 'referenciaContrato'
        },
        {
          headerName: this.$lang.PCI.PdrBonusPayment.DataTable.DateApproval,
          field: 'terminodiretortecnico',
          type: 'dateColumn'
        },
        {
          headerName: this.$lang.PCI.PdrBonusPayment.DataTable.Printed,
          field: 'pagamentoimpresso',
          valueGetter: param => {
            return param.data.pagamentoimpresso === 'true' ? 'SIM' : 'NÃO'
          }
        }
      ]
    }
  },
  components: {
    AgGridVue
  },
  methods: {
    onLoad () {
      loading.push()
      PDRRepository.GetPDRWorks({params: {empresaID: this.company.id, statusPDR: 4}})
        .then(response => {
          if (response.data.data) {
            if (response.data.code > 0) {
              const data = response.data.data[0]
              this.obrasRowData = data ? data.Data : []
              this.totalWorkRows = this.obrasRowData.length
            }
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onFilterChange (params) {
      this.totalWorkRows = params.api.rowModel.rowsToDisplay.length
    },
    setPrintId (params) {
      this.printPdrObraID = params.api.getModel().getRow(params.rowIndex).data.id
    },
    printPDF (params) {
      if (this.$store.state.account.account.funcionarioID) {
        loading.push()
        EmployeeRepository.GetById(this.$store.state.account.account.funcionarioID)
          .then(response => {
            if (response.data.data.codigo && response.data.data.codigo > 0) {
              this.printPDFConfirm(params)
            } else {
              loading.close()
              this.printPDFWarning(params)
            }
          })
          .catch(() => {
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => loading.close())
      } else {
        this.printPDFWarning(params)
      }
    },
    printPDFWarning (params) {
      this.$bvModal.msgBoxConfirm(this.$lang.PCI.PdrBonusPayment.WarningRequestPDC, {
        title: this.$lang.Common.Alerts.Warning,
        size: 'sm',
        buttonSize: 'sm',
        okTitle: this.$lang.PCI.PdrBonusPayment.ButtonPrint,
        cancelTitle: 'Cancelar',
        hideHeaderClose: false,
        centered: true
      })
        .then(ok => {
          if (ok) {
            this.printPDFConfirm(params)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    printPDFConfirm (params) {
      const lista = []
      if (params) {
        lista.push(params.api.getModel().getRow(params.rowIndex).data.id)
      } else {
        const selected = this.grid.getSelectedRows()
        if (selected.length > 0) {
          lista.push(...selected.map(i => i.id))
        }
      }
      this.printPDFExecute(lista)
      this.RequestForCreatePDC(lista)
    },
    printPDFExecute (params) {
      const lista = params
      if (lista.length > 0) {
        loading.push()
        PDRObraAvaliacaoRepository.PrintFormularioAprovacao(lista)
          .then(response => {
            if (response.data.code > 0) {
              const binary = window.atob(response.data.data.replace(/\s/g, ''))
              const len = binary.length
              const buffer = new ArrayBuffer(len)
              const view = new Uint8Array(buffer)
              for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i)
              }
              const blob = new Blob([view], {type: 'application/pdf'})

              const fileURL = URL.createObjectURL(blob)
              window.open(fileURL)
              this.onLoad()
            }
          })
          .catch(() => {
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => loading.close())
      } else {
        toast.error(this.$lang.PCI.PdrBonusPayment.ValidationSelected)
      }
    },
    RequestForCreatePDC (params) {
      //
      // Geração de pedido desabilitada até encontrar problemas
      //
      // toast.warning('Geração de pedidos temporariamente desabilidada!')

      if (this.$store.state.account.account.funcionarioID) {
        const lista = params
        if (lista.length > 0) {
          loading.push()
          PDRObraAvaliacaoRepository.PostRequestForCreatePDC(this.$store.state.account.account.funcionarioID, lista)
            .then((result) => {
              if (result.data.code === -400) {
                toast.error(result.data.message)
              } else {
                toast.success(this.$lang.PCI.PdrBonusPayment.SuccessRequestPDC)
                this.generatedMembers = result.data.data
                this.$refs.pdrPaymentModal.show()
              }
            })
            .catch((e) => {
              toast.error(this.$lang.PCI.PdrBonusPayment.ErrorRequestPDC)
              this.exceptionGeneration = e.message
              this.$refs.pdrPaymentModal.show()
              console.log(this.$lang.PCI.PdrBonusPayment.ErrorRequestPDC)
              console.log(e)
            })
            .finally(() => loading.close())
        }
      }
    },
    administrativeDirectorFinish () {
      const lista = this.grid.getSelectedRows().filter(x => x.pagamentoimpresso === 'true')
      if (lista.length === 0) {
        toast.error(this.$lang.PCI.PdrBonusPayment.ValidationSelectPrited)
        return
      }

      let messageConfirmation = this.$lang.Common.LabelConfirmation
      if (this.grid.getSelectedRows().filter(x => x.pagamentoimpresso === 'false').length > 0) {
        messageConfirmation = this.$lang.PCI.PdrBonusPayment.ValidationPrintedOnly
      }

      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          messageConfirmation
        ]),
        h('br')
      ])

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: this.$lang.PCI.PdrBonusPayment.ValidationTitle,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then((value) => {
          if (value) {
            loading.push()
            PDRObraAvaliacaoRepository.PostAdministrativeDirectorFinish(lista.map(i => i.id))
              .then(() => {
                this.printPdrObraID = null
                this.obrasRowData = this.obrasRowData.filter(row => {
                  return lista.indexOf(row) === -1
                })
                toast.success(this.$lang.Common.Alerts.Success)
              })
              .catch(error => {
                console.log(error)
                toast.error(this.$lang.Common.Alerts.Error)
              })
              .finally(() => loading.close())
          }
        })
    },
    onGridReady (params) {
      this.grid = params.api
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    }
  },
  beforeMount () {
    this.onLoad()
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/pdrbonuspayment/pdrbonuspayment.js